import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type BeneficiaryDeletionFailedAction = {
	type: 'BENEFICIARY_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): BeneficiaryDeletionFailedAction => ({
	type: 'BENEFICIARY_DELETION_FAILED',
	payload,
});
